import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-valuable-object-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_459_2065)">
        <path
          d="M12 23.2419L18 17.2419V6.74194L12 0.741943L6 6.74194V17.2419L12 23.2419Z"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 0.741943V23.2419"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 6.74194H18"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 17.2419H18"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 11.9919H23.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.25 3.74194L21.75 2.24194"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.25 20.2419L21.75 21.7419"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 11.9919H0.75"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.75 3.74194L2.25 2.24194"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.75 20.2419L2.25 21.7419"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_459_2065">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class ValuableObjectInsuranceIconComponent extends BaseIconComponent {}
